export { default as Root } from './Root';
export { default as Game } from './Game';
export { default as Test } from './Test';
export { default as NotFound } from './NotFound';
export * from './test';